
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-page/[eventName]",
      function () {
        return require("private-next-pages/landing-page/[eventName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing-page/[eventName]"])
      });
    }
  